
<1<<>>!>!<template>
  <div class="step-select-document-type p-4">
    <form data-vv-scope="step-1-part-1" v-on:submit.prevent autocomplete="off">
      <b-form-group label="Tipo de Documento" label-for="document-type-select" class="mb-4">
        <b-form-select
          id="document-type-select"
          v-model="selectedType"
          :options="documentTypes"
          size="lg"
          @change="onTypeSelected"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>
              Selecciona un tipo de documento
            </b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>
      <div class="row mt-1 d-flex align-items-end">
        <div class="col-12">
          <h4>Identificación del remitente</h4>
        </div>
        <div class="col-12 d-flex align-items-center mt-5">
          <h6>Remitente:</h6>
          <b-form-group>
            <b-form-radio-group
              id="sender-types"
              v-model="step.sender"
              name="sender-type"
              :disabled="isBlocked"
            >
              <b-form-radio
                @change="clearSender()"
                class="ml-3 mr-5"
                value="CIU"
                data-cy="check-citizen"
              >
                Ciudadano/a
              </b-form-radio>
              <b-form-radio
                @change="clearSender()"
                class="ml-3 mr-5"
                value="SAN"
                data-cy="health-check"
              >
                Sanitaria
              </b-form-radio>
              <b-form-radio
                @change="clearSender()"
                class="mr-5"
                value="PJU"
                data-cy="check-legal-entity"
              >
                Persona Jurídica
              </b-form-radio>
              <b-form-radio
                @change="clearSender()"
                class="mr-5"
                value="OES"
                data-cy="check-state-agency"
              >
                Organismo del estado
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <vs-input
            autocomplete="off"
            class="w-100"
            :label="step.sender === 'CIU' ? 'Rut Emisor' : 'Rut remitente'"
            v-model="step.senderIut"
            data-vv-as="rut"
            name="senderIut"
          />
        </div>
        <div class="col-6">
          <vs-input
            v-model="step.senderName"
            autocomplete="off"
            class="w-100"
            :label="step.sender === 'CIU' ? 'Nombre *' : 'Nombre remitente *'"
            data-vv-as="nombre"
            v-validate="'required|max:200'"
            name="senderName"
            :danger="errors.has('step-1-part-1.senderName')"
            :danger-text="errors.first('step-1-part-1.senderName')"
          />
        </div>
      </div>
      <div class="row mt-3">
        <div
          class="col-6"
          v-if="step.sender === 'SAN' || step.sender === 'PJU'"
        >
          <vs-input
            autocomplete="off"
            class="w-100"
            :label="iutLabel"
            v-model="step.senderCompanyIut"
            :data-vv-as="iutLabel.toLowerCase()"
            v-validate="{ validateRut: true }"
            name="senderCompanyIut"
            :danger="errors.has('step-1-part-1.senderCompanyIut')"
            :danger-text="errors.first('step-1-part-1.senderCompanyIut')"
          />
        </div>
        <div
          class="col-6"
          v-if="step.sender === 'PJU' ||
          step.sender === 'OES' ||
          step.sender === 'SAN'"
        >
          <vs-input
            v-if="step.sender === 'PJU' || step.sender === 'OES'"
            v-model="step.senderCompanyName"
            autocomplete="off"
            class="w-100"
            :label="nameLabel"
            :data-vv-as="nameLabel.replace('*', '').toLowerCase()"
            v-validate="{
              required: step.sender === 'PJU' || step.sender === 'OES',
              max: '200'
            }"
            name="senderCompanyName"
            :danger="errors.has('step-1-part-1.senderCompanyName')"
            :danger-text="errors.first('step-1-part-1.senderCompanyName')"
          />
          <ListSanitaryCompanies
            v-if="step.sender === 'SAN'"
            autocomplete="off"
            data-vv-as="empresa sanitaria"
            v-model="step.senderCompanyName"
            name="senderCompanyName"
            :isClearable="false"
            label="Empresas Sanitarias *"
            ref="sanitaryCompanies"
            v-validate="{
              required: step.sender === 'SAN',
              max: '200'
            }"
            @input="setSanitary"
            :clearSanitary="clearSanitary"
            :danger="errors.has('step-1-part-1.senderCompanyName')"
            :danger-text="errors.first('step-1-part-1.senderCompanyName')"
          />
        </div>
        <div class="col-md-6 mt-3">
          <ListProcess
            class="w-100"
            autocomplete
            label="Proceso *"
            placeholder="Seleccione..."
            name="process"
            v-model="step.process"
            @get-option-id="getOptionId"
            @change="updateNumeration"
            data-vv-as="proceso"
            :danger="errors.has('step-1-part-1.process')"
            :danger-text="errors.first('step-1-part-1.process')"
            v-validate="'required'"
            ref="process"
          />
        </div>
        <div class="col-md-6 mt-3">
          <ListSubProcess
            class="w-100"
            autocomplete
            label="Subproceso *"
            name="subProcess"
            v-model="step.subProcess"
            @change="updateNumeration"
            :parent-value="processId"
            data-vv-as="subproceso"
            v-validate="'required'"
            :danger="errors.has('step-1-part-1.subProcess')"
            :danger-text="errors.first('step-1-part-1.subProcess')"
            ref="subProcess"
          />
        </div>
      </div>
    </form>
    <form data-vv-scope="step-1-part-2">
      <div class="row mb-3">
        <div class="col-12">
          <h4>Responsable *</h4>
          <small>
            Para cambiar el destinatario, solo ingrese uno nuevo y se reemplazará el actual
          </small>
        </div>
      </div>
      <SelectSubject
        @add-subject="addSubject"
        scope="step-1-part-2"
      />
      <div class="row mb-3">
        <div class="col-12">
          <TableSubjects
            v-if="step.subjects"
            :subjects="step.subjects"
            v-model="step.subjectsSelected"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <label>Documento Reservado</label>
        </div>
        <div class="col-md-1">
          <vs-radio
            vs-name="isPrivate"
            :vs-value="2"
            v-model="step.isPrivate"
          >
            Si
          </vs-radio>
        </div>
        <div class="col-md-1">
          <vs-radio
            vs-name="isPrivate"
            :vs-value="0"
            v-model="step.isPrivate"
          >
            No
          </vs-radio>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ListSanitaryCompanies
  from "@/febos/chile/dnt/components/wizard/companies/61221000-4/components/ListSanitaryCompanies.vue";
import ListProcess from "@/febos/chile/lists/components/ListProcess.vue";
import ListSubProcess from "@/febos/chile/lists/components/ListSubProcess.vue";
import TableSubjects from "@/febos/chile/dnt/components/wizard/companies/61221000-4/components/TableSubjects.vue";
import SelectSubject from "@/febos/chile/dnt/components/wizard/companies/61221000-4/components/SelectSubject.vue";

export default {
  name: 'StepSelectDocumentType',
  components: {SelectSubject, TableSubjects, ListSubProcess, ListProcess, ListSanitaryCompanies},
  props: {
    draft: {
      type: Object,
      default: function() { return {}; }
    },
    wizard: {
      type: Object,
      required: true
    }
  },
  data() {
    const { id } = this.$route.params;
    return {
      isBlocked: !!id,
      error: {
        message: ''
      },
      processId: '',
      step: {
        isPrivate: 0,
        numberExp: '',
        origin: '', // ver como lo vamos a usar
        sender: 'CIU',
        senderAgency: '',
        senderIut: '',
        senderName: '',
        senderCompanyIut: '',
        senderCompanyName: '',
        senderComune: '',
        senderAddress: '',
        senderEmail: '',
        senderPhone: '',
        subjectOffice: '',
        documentType: '',
        documentCode: '',
        issueDate: '',
        rifCode: '',
        fileNumber: '',
        numberRidex: '',
        numberSac: '',
        fileNumberEntry: '',
        responsible: '',
        documentNumber: '',
        process: '',
        subProcess: '',
        matter: '',
        description: '',
        mainFile: {},
        additionalFiles: [],
        subjects: [],
        copies: [],
        subjectsSelected: [],
        copiesSelected: [],
        linkToFolder: '',
        entryFormatFile: '',
        declaration: false,
        ...this.draft
      },
      selectedType: null,
      documentTypes: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('DocManagement', ['getRepositories']),
    ...mapGetters('List', [
      'documentsState',
      'sanitaryCompaniesState',
      'documentProcessState'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    iutLabel() {
      if (this.step.sender === 'SAN') {
        return 'Rut Sanitaria';
      }
      if (this.step.sender === 'PJU') {
        return 'Rut Empresa';
      }
      return 'Rut';
    },
    nameLabel() {
      if (this.step.sender === 'SAN') {
        return 'Nombre empresa sanitaria';
      }
      if (this.step.sender === 'PJU') {
        return 'Razón social *';
      }
      if (this.step.sender === 'OES') {
        return 'Nombre de institución *';
      }
      return '';
    },
  },
  methods: {
    updateNumeration() {
      const { id } = this.$route.params;
      if (id) {
        this.step.numberExp = 0;
      }
    },
    setSanitary() {
      const sanitary = this.sanitaryCompaniesState.list
        .find((option) => option.label === this.step.senderCompanyName);
      if (sanitary && sanitary.extra) {
        this.step.senderCompanyIut = sanitary.extra.rut;
        this.step.senderAddress = sanitary.extra.direccion;
        this.step.senderComune = sanitary.extra.comuna;
        this.step.senderCompanyName = sanitary.label;
      }
    },
    clearSanitary() {
      this.step.senderCompanyName = '';
      this.step.senderCompanyIut = '';
      this.step.senderAddress = '';
    },
    clearSender() {
      this.step.senderCompanyIut = '';
      this.step.senderAddress = '';
      this.step.senderComune = '';
      this.step.senderCompanyName = '';
    },
    getOptionId(id) {
      this.processId = id;
    },
    loadDocumentTypes() {
      var typesByCompany = {
        '72235100-2': [
          { value: 'ACUCORE', text: 'Acuerdo CORE', extra: {
              "code": 'ACUCORE', // numeracion
              "entryType": '1', // si es entrada, salida o interno
              "numOf": true,
              "numInt": false,
              "uso": {
                "contraloria": false,
                "tramite": false,
                "numeracion": true
              },
              "idDocDigital": "5"
            }
          },
          { value: 'BIT', text: 'Bitácora ' + new Date().getFullYear() },
          { value: 'MEMO', text: 'Memorándum' },
          { value: 'OF', text: 'Oficio' },
          { value: 'OFCORE', text: 'Oficio CORE' },
          { value: 'ODP', text: 'Orden de Pago con Cargo a Gasto de Representación' },
          { value: 'RES', text: 'Resolución Exenta' },
          { value: 'RESUGDPS', text: 'Resolución Exenta UGDP-S' },
          { value: 'SP', text: 'Solicitud de Presupuesto ' + new Date().getFullYear() },
          { value: 'SCP', text: 'Solicitud Compra de Pasajes' },
          { value: 'INF', text: 'Informe de uso y custodia de vehículos fiscales' },
          { value: 'SOGR', text: 'Solicitud Gasto de Representación' },
          { value: 'SEGR', text: 'Selección Proveedor Gasto de Representación' },
          { value: 'IDPC', text: 'Informe de Desempeño Proceso de Calificaciones' }
        ],
        '61980520-8': [
          { value: 'SCH', text: 'Solicitud convenio honorarios' },
          { value: 'GRC', text: 'Guía Recepción Conforme' },
          { value: 'CPSH', text: 'Convenio de prestación de servicios a honorarios' },
          { value: 'FISABS', text: 'Formulario inicial solicitud de adquisición de bienes o servicios' },
          { value: 'ACT', text: 'Informe de Actividades' }
        ],
        '61221000-4': [
          { value: 'AF', text: 'Acta de fiscalización' }
        ],
        '61808000-5': [
          { value: 'ADP', text: 'Aumento de Plazo' },
          { value: 'SV', text: 'Solicitudes Varias' }
        ]
      };
      const companyIut = this.company && this.company.iut ? this.company.iut : '';
      this.documentTypes = typesByCompany[companyIut] || [];
    },
    async addSubject(row) {
      if (row && row.subject && row.subject.id === this.currentUser.id) {
        this.$bvToast.toast(
          'No te puedes agregar como destinatario',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
        return;
      }
      const isSelected = this.step.subjectsSelected
        .some((subjectRow) => {
          if (subjectRow.subjectType.value === 'docDigital') return subjectRow.subjectTypeDigitalDoc.id === row.subjectTypeDigitalDoc.id;

          return subjectRow.subject.id === row.subject.id;
        });
      if (!isSelected) {
        this.step.subjects = [];
        this.step.subjectsSelected = [];
        this.step.subjects.push(row);
        this.step.subjectsSelected.push(row);
      } else {
        this.$bvToast.toast(
          'Ya agregaste este destinatario',
          {
            title: '¡Oye!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      }
    },
    onTypeSelected(value) {
      console.log('value', value)
    },
    validate() {
      if (this.selectedType === null) {
        this.$bvToast.toast('Por favor selecciona un tipo de documento', {
          title: 'Tipo de documento requerido',
          variant: 'warning',
          solid: true
        });
        return false;
      }

      return true;
    },

    getData() {
      return {
        documentType: this.selectedType,
      };
    },

    getStepData() {
      return this.getData();
    },

    isValid() {
      return Promise.resolve(this.validate());
    }
  },
  mounted() {
    this.loadDocumentTypes();

    if (this.draft && this.draft.documentType) {
      this.selectedType = this.draft.documentType;
      this.loadRepositories();
    }

    this.$emit('loaded');
  },
};
</script>

<style lang="scss" scoped>
.step-select-document-type {
  min-height: 400px;
}

.folder-tree-container {
  max-height: 40vh;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 10px;
  background-color: #fafafa;
}

.node-item {
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f0f0f0;
  }

  &.selected {
    background-color: rgba(103, 30, 133, 0.15);
    color: #671e85;
    font-weight: 600;
  }

  &.root-item {
    margin-bottom: 10px;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 10px;
  }
}

ul {
  list-style: none;
  padding-left: 0;
  margin: 0;
}
</style>
